export default ({ productArray, orderArray }) => {
  if (!productArray || !orderArray) return []
  if (productArray.length === 0 || orderArray.length === 0) return productArray

  return productArray.reduce((acc, product) => {
    const productOrder = orderArray.indexOf(product.handle)
    if (productOrder >= 0) {
      acc[productOrder] = product
    }

    return acc
  }, [])
}
